"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Banner = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  background-image: url(", ");\n  height: ", ";\n  padding: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundImage;
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
});

function BannerComponent(props) {
  var backgroundColor = props.backgroundColor,
      backgroundImage = props.backgroundImage,
      height = props.height,
      padding = props.padding,
      className = props.className;
  return /*#__PURE__*/_react.default.createElement(Banner, {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    height: height,
    padding: padding,
    className: className
  });
}

var _default = BannerComponent;
exports.default = _default;